import { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import { useDTEConfiguration } from '../../hooks/hacienda/useDTEConfiguration';
import DTEConfigurationFormComponent from '../../components/Hacienda/DTEConfigurationFormComponent';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const DTEConfigurationPage = () => {
  const {
    form,
    error,
    environments,
    currencies,
    billingModels,
    transmissionTypes,
    isLoading,
    isSubmitting,
    updateField,
    loadConfiguration,
    saveConfiguration,
    loadDropdowns,
  } = useDTEConfiguration();

  // Cargar datos iniciales
  useEffect(() => {
    const initialize = async () => {
      await loadConfiguration();
      await loadDropdowns();
    };
    initialize();
  }, []);

  // Manejo de cambios de selects
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    // convierte a número los campos ID
    const parsedValue =
      name === 'environmentId' ||
      name === 'currencyId' ||
      name === 'billingModelId' ||
      name === 'transmissionTypeId'
        ? Number(value)
        : value;

    updateField(name as keyof typeof form, parsedValue);
  };

  const handleSave = async () => {
    await saveConfiguration(form);
  };

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Configuración de Hacienda (DTE)" /> */}
      <BreadcrumbTwo />

      <SectionWrapper>
        <DTEConfigurationFormComponent
          form={form}
          errors={error ? { general: error } : {}}
          environments={environments}
          currencies={currencies}
          billingModels={billingModels}
          transmissionTypes={transmissionTypes}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          onChange={handleChange}
          onSave={handleSave}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default DTEConfigurationPage;
